



























































































import Vue from 'vue'
import { createNamespacedHelpers } from 'vuex'
import { deleteExtension } from '@/services/ExtensionsAndProformas'
import { deleteProforma } from '@/services/Proforma'

const contractModule = createNamespacedHelpers('contracts')

export default Vue.extend({
  name: 'ExtensionAndProformListTable',

  props: {
    extensionAndProformaList: {
      type: Array,
      required: true
    },
    contractId: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      bgWhite: 'bg-white',
      headers: [
        {
          text: 'TIPO DE DOCUMENTO',
          value: 'type',
          class: 'grey'
        },
        {
          text: 'CÓDIGO',
          value: 'name',
          class: 'grey'
        },
        {
          text: 'PRECIO',
          value: 'price',
          class: 'grey'
        },
        {
          text: 'FECHA CREACIÓN',
          value: 'createdAt',
          class: 'grey'
        },
        {
          text: 'ESTADO',
          value: 'status',
          class: 'grey'
        },
        {
          text: '',
          value: 'detail',
          sortable: false,
          class: 'grey'
        }
      ]
    }
  },

  computed: {
    ...contractModule.mapState([
      'objectCurrentConstruction',
      'objectCurrentContract'
    ])
  },

  methods: {
    ...contractModule.mapActions([
      'settingCameFromExtensions',
      'settingSelectedContractId'
    ]),

    goToDetail (type: string, id: number) {
      type === 'Proforma'
        ? this.$router.push(`/edit-proforma/${id}`)
        : type === 'Ampliación'
          ? this.goToExtensionDetail(id)
          : this.$router.push(`/edit-bill/${id}`)
    },

    canDelete (item) {
      const currentUser = this.$cookies.get('user')
      const currentUserId = currentUser.id
      const currentUserRole = currentUser.rol.name
      const isJefe = currentUserRole === 'Jefe de obra'
      const areJefes = currentUserRole === 'Jefe de obra' || 'Jefe de grupo'
      const isAdmin = currentUserRole === 'Administrador del sistema y usuarios'
      console.log('isAdmin:', isAdmin)
      if (item.type === 'Ampliación') {
        console.log('Ampliación')
        const signedByGM = item.content.signedByGM === true
        const signedByCM = item.content.signedByCM === true

        let createdByCurrentUser = false
        if (item.content.createdBy) {
          createdByCurrentUser = item.content.createdBy.id === currentUserId
        }

        const canAdminDelete =
          isAdmin &&
          (signedByCM === false || (signedByCM === true && signedByGM === false))
        console.log(' canAdminDelete:', canAdminDelete)
        console.log(18881, !signedByGM && (isJefe || createdByCurrentUser || canAdminDelete))

        return !signedByGM && (isJefe || createdByCurrentUser || canAdminDelete)
      }
      if (item.type === 'Proforma') {
        const signedProforma = item.content.signedByGM === false
        let createdByCurrentUserProforma = false
        if (item.content.createdBy) {
          createdByCurrentUserProforma = item.content.createdBy.id === currentUserId
        }
        return signedProforma && (areJefes || createdByCurrentUserProforma)
      }
      return false
    },

    async deleteExtensionOrProforma (item) {
      if (item.type === 'Ampliación') {
        await deleteExtension(item.content.id)
        window.location.reload()
      }
      if (item.type === 'Proforma') {
        await deleteProforma(item.content.id)
        window.location.reload()
      }
    },

    goToExtensionDetail (id: number) {
      this.settingCameFromExtensions(true)
      console.log(this.contractId)
      this.settingSelectedContractId(this.contractId)
      this.$router.push(`/edit-contract/${id}`)
    }
  }
})
